<div *ngIf="!collapsed()"
     [ngClass]="{ 'text-grey': disabled() }"
     style="font-size: 16px; margin-top: 16px">
    <b>Visit</b>
</div>
<div [ngClass]="{
    'sub-header': true,
    'text-grey': disabled()
    }">DECLARATION</div>
<div class="row overflow-auto">
    <div class="col"
         [ngClass]="visitFieldIsValid('lastPortOfCallId') ? 'text-grey' : 'text-red'">
        <pmis3-seaport-picker seaPortPickerTitle="Last Port of Call"
                              [seaports]="seaports()"
                              [value]="state().lastPortOfCallId"
                              (valueChange)="onValueChange(VesselVisitFieldKey.LastPortOfCallId, $event)"
                              [disabled]="disabled()"
                              [isRequired]="true"
                              [isValid]="visitFieldIsValid('lastPortOfCallId')">
        </pmis3-seaport-picker>
    </div>
    <img [src]="arrowUrl()"
         width="40"
         style="align-self: flex-end; margin:5px;" />
    <div class="col"
         [ngClass]="visitFieldIsValid('nextPortOfCallId') ? 'text-grey' : 'text-red'">
        <pmis3-seaport-picker seaPortPickerTitle="Next Port of Call"
                              [seaports]="seaports()"
                              [value]="state().nextPortOfCallId"
                              (valueChange)="onValueChange(VesselVisitFieldKey.NextPortOfCallId, $event)"
                              [disabled]="disabled()"
                              [isRequired]="true"
                              [isValid]="visitFieldIsValid('nextPortOfCallId')">
        </pmis3-seaport-picker>
    </div>
</div>
<div class="info-grid">
    <!-- <kendo-label [text]="'ETA Pilot Station'"
                    [ngClass]="visitFieldIsValid('pilotStationETA') ? 'text-grey' : 'text-red'">
        <kendo-datetimepicker placeholder="Choose a date"
                                [(value)]="etaPilotStation"
                                (valueChange)="updateVisit()"
                                [disabled]="disabled()"
                                [fillMode]="'outline'"
                                [class.border-red]="!visitFieldIsValid('pilotStationETA')">
        </kendo-datetimepicker>
    </kendo-label>
    <kendo-label [text]="'ETD Pilot Station'"
                    [ngClass]="visitFieldIsValid('pilotStationETD') ? 'text-grey' : 'text-red'">
        <kendo-datetimepicker placeholder="Choose a date"
                                [(value)]="etdPilotStation"
                                (valueChange)="updateVisit()"
                                [disabled]="disabled()"
                                [fillMode]="'outline'"
                                [class.border-red]="!visitFieldIsValid('pilotStationETD')">
        </kendo-datetimepicker>
    </kendo-label> -->
    @if (state().ntaParticipationDeclaration) {
    <kendo-label [text]="'Planned Time of Arrival - Pilot Station'"
                 class="text-grey">
        <kendo-datetimepicker placeholder="Choose a date"
                              [value]="state().pilotBoardingETA"
                              (valueChange)="onValueChange(VesselVisitFieldKey.PilotBoardingETA, $event)"
                              [disabled]="disabled()"
                              [fillMode]="'outline'"
                              [format]="dateFormat">

        </kendo-datetimepicker>
    </kendo-label>
    <kendo-label [text]="'Adjusted Time of Arrival - Pilot Station'"
                 class="text-grey">
        <kendo-datetimepicker placeholder="Choose a date"
                              [value]="state().pilotBoardingATA"
                              (valueChange)="onValueChange(VesselVisitFieldKey.PilotBoardingATA, $event)"
                              [disabled]="disabled()"
                              [fillMode]="'outline'"
                              [format]="dateFormat">
        </kendo-datetimepicker>
    </kendo-label>
    <kendo-label [text]="'Requested Time of Arrival - Berth'"
                 class="text-grey">
        <kendo-datetimepicker placeholder="Choose a date"
                              [value]="state().berthETA"
                              (valueChange)="onValueChange(VesselVisitFieldKey.BerthETA, $event)"
                              [disabled]="disabled()"
                              [fillMode]="'outline'"
                              [format]="dateFormat">
        </kendo-datetimepicker>
    </kendo-label>
    }
    <kendo-label [text]="'Name of Master'"
                 class="text-grey"
                 style="grid-column: span 2;">
        <kendo-textbox [value]="state().vesselMasterName"
                       (valueChange)="onValueChange(VesselVisitFieldKey.VesselMasterName, $event)"
                       [fillMode]="'outline'"
                       [placeholder]="'-'"
                       [disabled]="disabled()">
        </kendo-textbox>
    </kendo-label>
    <kendo-label [text]="'Vessel Contact Phone'"
                 class="text-grey">
        <kendo-textbox [value]="state().vesselPhone"
                       (valueChange)="onValueChange(VesselVisitFieldKey.VesselPhone, $event)"
                       [fillMode]="'outline'"
                       [placeholder]="'-'"
                       [disabled]="disabled()">
        </kendo-textbox>
    </kendo-label>
    <kendo-label [text]="'Vessel Contact Email'"
                 class="text-grey">
        <kendo-textbox [value]="state().vesselEmail"
                       (valueChange)="onValueChange(VesselVisitFieldKey.VesselEmail, $event)"
                       [fillMode]="'outline'"
                       [placeholder]="'-'"
                       [disabled]="disabled()">
        </kendo-textbox>
    </kendo-label>
    <kendo-label [text]="'Agent Name'"
                 class="text-grey">
        <kendo-textbox [value]="state().agentName"
                       (valueChange)="onValueChange(VesselVisitFieldKey.AgentName, $event)"
                       [fillMode]="'outline'"
                       [placeholder]="'-'"
                       [disabled]="disabled()">
        </kendo-textbox>
    </kendo-label>
    <kendo-label [text]="'Agent 24/7 Contact Phone'"
                 class="text-grey">
        <kendo-textbox [value]="state().agentPhone"
                       (valueChange)="onValueChange(VesselVisitFieldKey.AgentPhone, $event)"
                       [fillMode]="'outline'"
                       [placeholder]="'-'"
                       [disabled]="disabled()">
        </kendo-textbox>
    </kendo-label>
    <kendo-label [text]="'Agent 24/7 Contact Email'"
                 class="text-grey">
        <kendo-textbox [value]="state().agentEmail"
                       (valueChange)="onValueChange(VesselVisitFieldKey.AgentEmail, $event)"
                       [fillMode]="'outline'"
                       [placeholder]="'-'"
                       [disabled]="disabled()">
        </kendo-textbox>
    </kendo-label>
    <div class="col-floatinglabel-height d-inline-flex">
        <kendo-checkbox #nta
                        [checkedState]="state().ntaParticipationDeclaration === true"
                        (checkedStateChange)="onValueChange(VesselVisitFieldKey.NtaParticipationDeclaration, $event)"
                        [disabled]="disabled()">
        </kendo-checkbox>
        <kendo-label class="k-checkbox-label"
                     [ngClass]="{ 'text-grey': disabled() }"
                     [for]="nta"
                     text="NTA Participation Declaration">
        </kendo-label>
    </div>
</div>
<div class="mt-4">
    <kendo-label [text]="'Remarks'"
                 class="text-grey">
        <kendo-textarea style="width: 100%"
                        placeholder="Remarks"
                        [rows]="5"
                        [disabled]="disabled()"
                        [value]="state().remarks"
                        (valueChange)="onValueChange(VesselVisitFieldKey.Remarks, $event)"
                        [fillMode]="'outline'">
        </kendo-textarea>
    </kendo-label>
</div>

<div class="mt-4">
    <h6 class="my-1 font-larger-1 line-height-1"
        [ngClass]="{ 'text-grey': disabled() }"><b>VISIT ORGANIZATION</b></h6>
    <div class="d-flex flex-wrap"
         style="gap:12px;">
        @for (organization of state().organizations; track $index) {
        @if (!organization.isDeleted) {
        <pmis3-vessel-visit-detail-organization [organization]="organization"
                                                (deletedOrganization)="onDeletedOrganizationFromChild($event)"
                                                [disabled]="disabled()">
        </pmis3-vessel-visit-detail-organization>
        }
        }
        <pmis3-vessel-visit-detail-organization [disabled]="disabled()"
                                                (assignedOrganization)="onAssignedOrganizationFromChild($event)"
                                                (deletedOrganization)="onDeletedOrganizationFromChild($event)">
        </pmis3-vessel-visit-detail-organization>
    </div>
</div>